export default "__VITE_ASSET__CscBVddO__"